import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import SmallModuleHead from '@src/pc/index/components/SmallModuleHead';
import Chip from 'Chip';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const VideoColumn = ({ videoColumnHead, videoColumnFeed }) => {
    return (
        <div className={styles.original}>
            <Chip id="260480" type="struct" title="视频栏目头" content={videoColumnHead}>
                <SmallModuleHead />
            </Chip>
            <Chip id="287351" type="recommend" title="视频栏目列表">
                <div className={styles.originalBox}>
                    <div className={styles.originalPicBox}>
                        {videoColumnFeed.slice(0, 1).map((item, index) => {
                            const thumbnail = item?.thumbnails?.image?.[0]?.url || '';

                            return (
                                <a key={index} className={styles.originalPicLink} href={item.url} target="_blank">
                                    <img
                                        className={styles.originalPic}
                                        src={formatImageWebpAuto(thumbnail, 380, 214)}
                                    />
                                    <div className={styles.originalPicVideo} />
                                    <div className={styles.originalPicText}>{item.title}</div>
                                </a>
                            );
                        })}
                    </div>
                    <div className={styles.originalText}>
                        {videoColumnFeed.slice(1, 3).map((item, index) => {
                            return (
                                <div key={index} className={styles.originalTextItem}>
                                    <a className={styles.originalTextLink} href={item.url} target="_blank">
                                        <div className={styles.originalTextDot} />
                                        {item.title}
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Chip>
        </div>
    );
};

VideoColumn.propTypes = {
    videoColumnHead: PropTypes.object,
    videoColumnFeed: PropTypes.array,
};

export default errorBoundary(VideoColumn);
